var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-wrepper"},_vm._l((_vm.messages),function(msg,index){return _c('div',{key:index,staticClass:"message slideInRight faster animated",class:msg.type,domProps:{"innerHTML":_vm._s(msg.msg)}})}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df8a7ed4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/partials/Messaging.vue
// module id = 580
// module chunks = 187